/*
 * Jira Ticket:
 * Created Date: Wed, 22nd Apr 2020, 13:41:05 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
import React from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  image: {
    margin: '0.5rem',
    maxHeight: '10rem',
  },
});

const PreviewImageField = props => {
  const classes = useStyles(props);
  const translate = useTranslate();
  const { record } = props;
  if (record && (record.id || record.rawFile)) {
    return (
      <a
        href={record.url || record.undefined}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={record.url || record.undefined}
          className={classes.image}
          alt={translate('error.imageNotFound')}
        />
      </a>
    );
  }

  return null;
};

export default PreviewImageField;
